import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { DocumentListEffects } from './document-list.effects';
import { initialState, reducer } from './document-list.reducer';
import { createLocalStorageSyncReducer } from '../local-storage-sync';
import { DocumentListState } from './document-list.state';
import { getEnvironment } from '../../features/shared/utils/get-environment';

const syncMetaReducer = createLocalStorageSyncReducer<DocumentListState>({
  keys: ['searchFilter'],
  rehydrate: true,
  storage: localStorage,
  storageKeySerializer: (key) => `semeris-${getEnvironment()}-${key}`,
});

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('documentList', reducer, {
      initialState,
      metaReducers: [syncMetaReducer],
    }),
    EffectsModule.forFeature([DocumentListEffects]),
  ],
  providers: [DocumentListEffects],
})
export class DocumentListStoreModule {}
